export const initBookmark = () => ({
    pageIndex: 1,
    pageSize: 50,
});
